<prism-dialog
	data-testid="info-dialog"
	[visible]="true"
	cancelButton=""
	confirmButton=""
	*transloco="let t; prefix: 'scInfoDialog'"
>
	@if (!!data.title) {
		<span slot="dialog-title" class="sh-info-dialog-title">
			<div class="sh-icon-container">
				@if (data.showWarningIcon) {
					<prism-icon class="sh-warning-icon" icon="sh-warning-outline" />
				}
				@if (data.showBetaIcon) {
					<prism-beta-indicator />
				}
				<span [innerHtml]="data.title"></span>
			</div>
		</span>
	}

	@if (data.body) {
		<div class="sh-dialog-body" (click)="handleBodyClick($event)">
			@for (line of data.body; track $index) {
				<span class="prism-body-2" [innerHtml]="line"></span>
			}
			@if (data.doNotShowDialogId) {
				<prism-checkbox
					id="sh-confirm-dialog-do-not-show"
					class="sh-dialog-body-show-checkbox"
					[checked]="doNotShowDialog"
					(valueChange)="toggleDoNotShowDialog($event.detail)"
				>
					{{ t('no-show-dialog-again') }}
				</prism-checkbox>
			}
		</div>
	}

	<div slot="dialog-footer-buttons" class="footer">
		<prism-button variant="bright" id="sh-info-dialog-ok-button" (click)="close()">
			{{ data.okLabel }}
		</prism-button>
	</div>
</prism-dialog>
